import { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { HEADER_BAR_HEIGHT } from '../../consts';
import { ArdoqLoaderComponent, LoaderColor, LoaderSize } from '@ardoq/loader';

interface WidgetBodyProps {
  isLoading?: boolean;
  children?: ReactNode;
  hasHeader?: boolean;
}

const Body = styled.div<{
  $isLoading?: boolean;
  $hasHeader?: boolean;
}>`
  ${({ $hasHeader }) =>
    $hasHeader
      ? css`
          height: calc(100% - ${HEADER_BAR_HEIGHT}px);
        `
      : css`
          height: 100%;
        `}

  width: 100%;
  position: relative;
  ${({ $isLoading }) =>
    $isLoading &&
    css`
      opacity: 0.32;
      pointer-events: none;
    `};
`;

const ArdoqLoaderContainer = styled.div`
  position: absolute;
  /* 36 is loading text line height + 12px gap */
  top: calc(50% - ${(LoaderSize.MEDIUM + 36) / 2}px);
  left: calc(50% - ${(LoaderSize.MEDIUM + 22) / 2}px);
`;

const WidgetBody = ({ children, isLoading, hasHeader }: WidgetBodyProps) => (
  <Body $hasHeader={hasHeader}>
    {isLoading ? (
      <ArdoqLoaderContainer>
        <ArdoqLoaderComponent
          labelPosition={'vertical'}
          size={LoaderSize.MEDIUM}
          loaderColor={LoaderColor.BRAND}
          loaderType={'logo'}
        />
      </ArdoqLoaderContainer>
    ) : (
      children
    )}
  </Body>
);

export { WidgetBody };
